export enum ComponentName {
    CHANNEL_LIVE = "ChannelLive",
    CREDIT = "Credit",
    EPISODE = "Episode",
    FILTERS_VOD = "FiltersVod",
    CHANNEL = "Channel",
    MIXED = "Mixed",
    MOVIE = "Movie",
    PLUS = "Plus",
    PROGRAM = "Program",
    SEASONS = "Seasons",
    SHOW_ALL = "ShowAll",
    TABS_GENRES = "TabsGenres",
}
